module.exports = __webpack_public_path__ + "img/godetia.7a79c4da.jpg";